import React from 'react';

// chakra imports
import {
	Box,
	Flex,
	Drawer,
	DrawerBody,
	useColorModeValue,
	DrawerOverlay,
	useDisclosure,
	DrawerContent,
	DrawerCloseButton,
	VStack
} from '@chakra-ui/react';
import Icon from 'components/icons/Icon';
import Content from 'components/sidebar/components/Content';
import { renderThumb, renderTrack, renderView } from 'components/scrollbar/Scrollbar';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { useAuth } from 'contexts/AuthContext';
// utils
import { getVisibleSidebarRoutes } from 'utils/routeUtils';

// Assets
import { IoMenuOutline } from 'react-icons/io5';

function Sidebar(props: { routes: RoutesType[];[x: string]: any }) {
	const { routes } = props;
	const { user } = useAuth();

	// Filter routes to only show those that should be visible in sidebar for the current user
	const visibleRoutes = getVisibleSidebarRoutes(routes, user?.role || null);

	let variantChange = '0.2s linear';
	let shadow = useColorModeValue('14px 17px 40px 4px rgba(112, 144, 176, 0.08)', 'unset');
	// Chakra Color Mode
	let sidebarBg = useColorModeValue('white', 'navy.800');
	let sidebarMargins = '0px';

	// SIDEBAR
	return (
		<Box display={{ sm: 'none', xl: 'block' }} position='fixed' minH='100%'>
			<Box
				bg={sidebarBg}
				transition={variantChange}
				w='300px'
				h='100vh'
				m={sidebarMargins}
				minH='100%'
				overflowX='hidden'
				boxShadow={shadow}>
				<Scrollbars
					autoHide
					renderTrackVertical={renderTrack}
					renderThumbVertical={renderThumb}
					renderView={renderView}>
					<Content routes={visibleRoutes} />
				</Scrollbars>
			</Box>
		</Box>
	);
}

// FUNCTIONS
export function SidebarResponsive(props: { routes: RoutesType[] }) {
	let sidebarBackgroundColor = useColorModeValue('white', 'navy.800');
	let menuColor = useColorModeValue('navy.700', 'white');
	// // SIDEBAR
	const { isOpen, onOpen, onClose } = useDisclosure();
	const btnRef = React.useRef<HTMLDivElement>(null);
	const { user } = useAuth();

	const { routes } = props;

	// Filter routes to only show those that should be visible in sidebar for the current user
	const visibleRoutes = getVisibleSidebarRoutes(routes, user?.role || null);

	// let isWindows = navigator.platform.startsWith("Win");
	//  BRAND

	return (
		<Flex display={{ sm: 'flex', xl: 'none' }} alignItems='center'>
			<Flex 
				ref={btnRef} 
				w='max-content' 
				h='max-content' 
				onClick={onOpen}
				p='4px'
				borderRadius='6px'
				_hover={{ bg: useColorModeValue('gray.100', 'gray.700') }}
				cursor='pointer'
				me='10px'
			>
				<VStack spacing='2px' w='20px' h='20px' justify='center'>
					<Box w='100%' h='2px' bg={menuColor} borderRadius='1px' />
					<Box w='100%' h='2px' bg={menuColor} borderRadius='1px' />
					<Box w='100%' h='2px' bg={menuColor} borderRadius='1px' />
				</VStack>
			</Flex>
			<Drawer
				isOpen={isOpen}
				onClose={onClose}
				placement={document.documentElement.dir === 'rtl' ? 'right' : 'left'}
				finalFocusRef={btnRef}>
				<DrawerOverlay />
				<DrawerContent w='285px' maxW='285px' bg={sidebarBackgroundColor}>
					<DrawerCloseButton
						zIndex='3'
						onClick={onClose}
						_focus={{ boxShadow: 'none' }}
						_hover={{ boxShadow: 'none' }}
					/>
					<DrawerBody maxW='285px' px='0rem' pb='0'>
						<Scrollbars
							autoHide
							renderTrackVertical={renderTrack}
							renderThumbVertical={renderThumb}
							renderView={renderView}>
							<Content routes={visibleRoutes} />
						</Scrollbars>
					</DrawerBody>
				</DrawerContent>
			</Drawer>
		</Flex>
	);
}
// PROPS

export default Sidebar;
